/**
 * Leads Page
 * Standalone page for lead management
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import LeadsTab from './LeadsTab';

const LeadsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const minScore = searchParams.get('minScore') ? Number(searchParams.get('minScore')) : undefined;

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {minScore ? 'High Score Leads' : 'Leads'}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {minScore ? `Leads with AI score above ${minScore}` : 'Manage and track your leads'}
        </Typography>
      </Box>
      <LeadsTab initialMinScore={minScore} />
    </Container>
  );
};

export default LeadsPage;
